import { render, staticRenderFns } from "./honors.vue?vue&type=template&id=be05582e&scoped=true&"
import script from "./honors.vue?vue&type=script&lang=js&"
export * from "./honors.vue?vue&type=script&lang=js&"
import style0 from "./honors.vue?vue&type=style&index=0&id=be05582e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be05582e",
  null
  
)

export default component.exports